// src/pages/settings/tabs/ResetPasswordTab.jsx
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useSendResetEmail } from '../../../features/auth/api';
import { auth } from '../../../lib/firebase';

export default function ResetPasswordTab() {
  const [email] = useState(auth.currentUser?.email ?? '');
  const sendReset = useSendResetEmail();

  const onSend = () => {
    const target = email.trim();
    if (!target) return toast.warn('Enter an email.');
    sendReset.mutate(target, {
      onSuccess: () => toast.success('If an account exists, a reset link was sent.'),
      onError: () => toast.error('Could not send reset email.'),
    });
  };

  return (
    <div className="card">
      <h2 className="card__title">Password Reset</h2>
      <p className="card__subtitle">We’ll email you a secure link to reset your password.</p>

      <div className="actions">
        <button className="btn btn--primary" onClick={onSend} disabled={sendReset.isPending}>
          {sendReset.isPending ? 'Sending...' : 'Send Reset Email'}
        </button>
      </div>
    </div>
  );
}
